import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, roles, check }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-100">
        <div className="text-xs tracking-[0.3em] uppercase font-bold text-zinc-500">
          Loading...
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    // Fallback: limited users get timecard, others get dashboard
    const home = user.role === "limited" ? "/my-timecard" : "/";
    return <Navigate to={home} replace />;
  }
  if (typeof check === "function" && !check(user)) {
    const home = user.role === "limited" ? "/my-timecard" : "/";
    return <Navigate to={home} replace />;
  }
  return children;
}
